import React from 'react'
import { UCFUploadWidget } from '@chegg-wt/core/components/UCFUploadWidget'
import { LvpMarginWrapper } from '@chegg-wt/core/components/Layouts/LargeVideoPlayerLayout'
import { Config } from '@chegg-wt/core/config'
import { CITE_THIS_FOR_ME } from '@chegg-wt/core/constants/site'
import * as Styled from './styled'

export const widgetTestId = 'upload-widget-test'

export const HEADING_TEXT = 'Check your paper for grammar and plagiarism'
export const CTFM_SUBHEADING_TEXT = `Catch plagiarism and grammar mistakes with Chegg's paper checker`
export const SUBHEADING_TEXT = Config.shouldOpenInNewTab
  ? CTFM_SUBHEADING_TEXT
  : 'Catch plagiarism and grammar mistakes with our paper checker'
export const WIDGET_SITE = Config.shouldOpenInNewTab
  ? CITE_THIS_FOR_ME
  : Config.tokenSiteCode

const HomepageUploadWidget: React.FC<{}> = () => {
  return (
    <Styled.Container data-test={widgetTestId}>
      <LvpMarginWrapper>
        <UCFUploadWidget
          headingText={HEADING_TEXT}
          subheadingText={SUBHEADING_TEXT}
          site={WIDGET_SITE}
        />
      </LvpMarginWrapper>
    </Styled.Container>
  )
}

export default HomepageUploadWidget
